/**
 * Überlagerter Dialog.
 *
 * Für Vorgänge, die eine Angabe brauchen, bevor sie laufen dürfen — vor
 * allem Stornieren: Ohne Grund kein Storno, das ist eine GoBD-Anforderung
 * und keine Formalie. Ein Dialog erzwingt die Eingabe an der Stelle, an der
 * die Entscheidung fällt.
 */
import { useEffect, type ReactNode } from 'react';

export function Dialog({
  titel,
  breit,
  schliessen,
  fuss,
  children,
}: {
  titel: string;
  breit?: boolean;
  schliessen: () => void;
  fuss?: ReactNode;
  children: ReactNode;
}): ReactNode {
  // Escape schließt. Wer einen Dialog versehentlich öffnet, soll ihn ohne
  // Maus wieder loswerden.
  useEffect(() => {
    const beiTaste = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') schliessen();
    };
    window.addEventListener('keydown', beiTaste);
    return () => window.removeEventListener('keydown', beiTaste);
  }, [schliessen]);

  return (
    <div
      className="dialog-grund"
      onClick={(e) => {
        // Nur ein Klick auf den Hintergrund schließt, nicht einer, der im
        // Dialog begann und dort endete.
        if (e.target === e.currentTarget) schliessen();
      }}
    >
      <div className={`dialog${breit ? ' breit' : ''}`} role="dialog" aria-modal="true" aria-label={titel}>
        <div className="dialog-kopf">
          <h2>{titel}</h2>
          <button type="button" className="knopf schlicht" onClick={schliessen} aria-label="Schließen">
            ✕
          </button>
        </div>
        <div className="dialog-koerper">{children}</div>
        {fuss ? <div className="dialog-fuss">{fuss}</div> : null}
      </div>
    </div>
  );
}
